import {Badge, Button, Col, Form, Modal, Row, Table} from "react-bootstrap";
import React, {useEffect, useState} from "react";
import {Link} from "react-router-dom";

const GamesConvocatedModal = (props) => {
    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 10;

    // Calcola i membri attuali da visualizzare
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentMembers = props.convocatedMembers ? props.convocatedMembers.slice(indexOfFirstItem, indexOfLastItem) : [];

    // Funzioni di paginazione
    const totalPages = Math.ceil((props.convocatedMembers?.length || 0) / itemsPerPage);
    const handleNextPage = () => setCurrentPage(prev => Math.min(prev + 1, totalPages));
    const handlePrevPage = () => setCurrentPage(prev => Math.max(prev - 1, 1));

    const handleClose = () => {
        props.setShow(false);
        props.setConvocationList()
    };

    useEffect(() => {
        console.log(props.convocatedMembers);
        setCurrentPage(1); // Reset della pagina corrente quando si aprono nuovi dati
    }, [props.convocatedMembers]);

    return (
        <Modal show={props.show} onHide={handleClose}
               className={'modal-md'}
               centered={true}>
            <Modal.Header closeButton></Modal.Header>
            <Modal.Body className={'d-flex flex-column'}>
                <Table className={'table-responsive'}>
                    <thead>
                    <tr className={'shadow-none'}>
                        <th className={'bkg-primary text-white text-start'}>Nome convocato</th>
                        <th className={'bkg-primary text-white text-start'}>Presenza</th>

                    </tr>
                    </thead>
                    <tbody>
                    {currentMembers && currentMembers.length > 0 ? currentMembers.map((member, index) => {
                        return (
                            <tr key={index} className={'me-2'}>
                                <td>
                                    <img className={'img-fluid rounded-5 me-3'} style={{width: '30px'}}
                                         src={`${member?.profile_picture}`} alt="profile"/>
                                    <Link className={'text-decoration-none'} to={'/soci/dettaglio-socio/' + member.id}>
                                        <span>{member.player_name} </span>
                                    </Link>
                                </td>
                                <td><Badge
                                    bg={member.accepted === null ? 'dark' : (member.accepted === 0 ? 'danger' : 'success')}>{member.accepted === null ? 'Non confermato' : (member.accepted === 0 ? 'No' : 'Si')}</Badge></td>

                            </tr>
                        );
                    }) : (
                        <tr>
                            <td colSpan="3">Nessun Convocato</td>
                        </tr>
                    )}
                    </tbody>
                </Table>
                {/* Controlli di paginazione */}
                {props.convocatedMembers && props.convocatedMembers.length > itemsPerPage && (
                    <div className="d-flex justify-content-between align-items-center mt-3">
                        <Button className={'bkg-second border-0'} onClick={handlePrevPage} disabled={currentPage === 1}>
                            Pagina precedente
                        </Button>
                        <span>Pagina {currentPage} di {totalPages}</span>
                        <Button className={'bkg-second border-0'} onClick={handleNextPage} disabled={currentPage === totalPages}>
                            Pagina successiva
                        </Button>
                    </div>
                )}
            </Modal.Body>
        </Modal>
    );
}
export default GamesConvocatedModal